import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import withRouter from 'components/components/common/withRouter';
import { setUserLogout } from 'components/actions/authActions';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';


class PrivacyPolicyContent extends Component {

  render() {
    var list = this.props.list;
    var listNested = this.props.listNested === false;

    if (listNested) {
      return (
        <ul>
          {(
            list.map((item,index)=> (
              <li key={index}>
                {item.content}
              </li>
          ))
          )}
        </ul>
      );
    } else {
      return (
        list.map((item,index)=> (
          (item.list) ?
            <Fragment key={index}>
              <PrivacyPolicyContent list={item.list} listNested={false} />
            </Fragment>
            :
            <p key={index}>
              {item.content}
            </p>
        ))
      );
    }

  }
}

class PrivacyPolicyAddress extends Component {

  render() {
    var address = this.props.address;
    return (
      address.map((item,index)=> (
        <div key={index}>
          {item.content}
        </div>
      ))
    );
  }
}

class PrivacyPolicy extends Component {

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.landing.privacyPolicy.' + key + '.list');
  }

  transAddress = (key) => {
    return TransHelper.translate(this.props.locale, 'content.landing.privacyPolicy.' + key + '.address');
  }

  render() {
    const {isLogged } = this.props;

    return (
      <div className="content content--lp content--lp-text">
        <div className="row row--text row--text-wide">

          <div className="headline headline--subpage">
            <h1><T>content.landing.privacyPolicy.title</T></h1>
          </div>

          <ol className="terms-list terms-list--privacy">
            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.introduction.title</T></h3>
              <PrivacyPolicyContent list={this.trans('introduction')} />
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.whatPersonalInformation.title</T></h3>
              <PrivacyPolicyContent list={this.trans('whatPersonalInformation')} />
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.whatWeUsePersonalInformationFor.title</T></h3>
              <PrivacyPolicyContent list={this.trans('whatWeUsePersonalInformationFor')} />
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.whoWeSharePersonalInformationWith.title</T></h3>
              <PrivacyPolicyContent list={this.trans('whoWeSharePersonalInformationWith')} />
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.howLongWeStorePersonalInformation.title</T></h3>
              <PrivacyPolicyContent list={this.trans('howLongWeStorePersonalInformation')} />
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.yourRights.title</T></h3>
              <PrivacyPolicyContent list={this.trans('yourRights')} listNested={ true } />
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.cookies.title</T></h3>
              <PrivacyPolicyContent list={this.trans('cookies')} />
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.changesToThePrivacyStatement.title</T></h3>
              <PrivacyPolicyContent list={this.trans('changesToThePrivacyStatement')} />
            </li>

            <li className="terms-list__item">
              <h3><T>content.landing.privacyPolicy.contactInformation.title</T></h3>
              <PrivacyPolicyContent list={this.trans('contactInformation')} />
              <address itemScope itemType="http://schema.org/Organization">
                <PrivacyPolicyAddress address={this.transAddress('contactInformation')} />
              </address>
            </li>
          </ol>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    { setUserLogout }
  )(PrivacyPolicy));
